import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AppBar, IconButton, Toolbar } from "@material-ui/core";
import { AccountCircle } from "@material-ui/icons";
import AccessTemplate from "../Support/AccessTemplate";
import HelpIcon from "@material-ui/icons/Help";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import { Link } from "react-router-dom";

import Logo from "./images/sofar-logo.svg";
import "./PrivateNavbar.scss";

const useStyles = makeStyles(theme => ({
  root: {
    background: "RGB(37, 42, 63)",
    flexGrow: 1,
    height: "10vh",
    width: "100vw",
    "@media only screen and (min-height: 550px)": {
      height: "9vh"
    },
    "@media only screen and (min-height: 700px)": {
      height: "7.5vh"
    },
    "@media only screen and (min-height: 900px)": {
      height: "6vh"
    }
  },
  accessForm: {
    background: "transparent",
    boxShadow: "none",
    color: "#FFF",
    textAlign: "left",
    width: "50vw"
  },
  copyFields: {
    background: "#171F31",
    borderRadius: "2px",
    color: "#FFF",
    fontSize: "0.8em",
    height: "50px",
    marginTop: "5px",
    padding: "10px 20px",
    width: "20vw",
    "@media only screen and (max-width: 640px)": {
      width: "40vw"
    },
    "@media only screen and (max-width: 450px)": {
      width: "50vw"
    }
  },
  dialogTitle: {
    background: "#43475B",
    fontSize: "40px",
    fontWeight: "bold",
    padding: "1em 2em 1em 2.5em",
    textAlign: "left",
    "@media only screen and (max-width: 650px)": {
      fontSize: "30px"
    },
    "@media only screen and (max-width: 450px)": {
      fontSize: "20px"
    }
  },
  inputLabel: {
    fontWeight: "bold",
    marginTop: "2vh"
  },
  logo: {
    marginRight: theme.spacing(2),
    width: "100px"
  },
  menu: {
    background: "RGB(37, 42, 63)",
    color: "#FFF",
    width: "200px"
  },
  menuItem: {
    lineHeight: "2",
    "&:hover": {
      backgroundColor: "#161822"
    }
  },
  navbarButtons: {
    marginLeft: "auto"
  },
  profileDropdown: {
    color: "#FFF"
  },
  rootDialog: {
    background: "rgba(18, 20, 30, 0.9)",
    color: "#FFF",
    maxWidth: "100%",
    "@media only screen and (max-width: 640px)": {
      minWidth: "100vw"
    }
  },
  trialForm: {
    background: "transparent",
    boxShadow: "none",
    color: "#FFF",
    // height: '50vh',
    textAlign: "left",
    width: "50vw"
  }
}));

const PrivateNavbar = () => {
  const classes = useStyles();

  const [accountMenuAnchorEl, setAccountMenuAnchorEl] = useState(false);
  const [iconMenuAnchorEl, setIconMenuAnchorEl] = useState(false);

  const handleAccountMenuClick = event => {
    setAccountMenuAnchorEl(event.currentTarget);
  };

  const handleHelpMenuClick = event => {
    setIconMenuAnchorEl(event.currentTarget);
  };

  const handleAccountMenuClose = () => {
    setAccountMenuAnchorEl(false);
  };

  const handleHelpMenuClose = () => {
    setIconMenuAnchorEl(false);
  };

  return (
    <React.Fragment>
      <AppBar className={classes.root} position="static">
        <Toolbar>
          <Link to="/">
            <img
              className={classes.logo}
              src={Logo}
              alt="Sofar Ocean Technologies Logo"
            />
          </Link>
          <span className={classes.navbarButtons}>
            <AccessTemplate />
            <IconButton
              aria-label="Notifications"
              color="inherit"
              onClick={handleHelpMenuClick}
            >
              <HelpIcon />
            </IconButton>
            <Menu
              id="icon-menu"
              classes={{ paper: classes.menu }}
              anchorEl={iconMenuAnchorEl}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center"
              }}
              getContentAnchorEl={null}
              keepMounted
              open={Boolean(iconMenuAnchorEl)}
              onClose={handleHelpMenuClose}
            >
              <MenuItem
                classes={{ root: classes.menuItem }}
                onClick={handleHelpMenuClose}
              >
                <a
                  href="https://docs.sofarocean.com/"
                  style={{ color: "#FFF", textDecoration: "none" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  API Documentation
                </a>
              </MenuItem>
              <MenuItem
                classes={{ root: classes.menuItem }}
                onClick={handleHelpMenuClose}
              >
                Support
              </MenuItem>
            </Menu>
            <IconButton
              aria-label="Login"
              color="inherit"
              onClick={handleAccountMenuClick}
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="account-menu"
              classes={{ paper: classes.menu }}
              anchorEl={accountMenuAnchorEl}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center"
              }}
              getContentAnchorEl={null}
              keepMounted
              open={Boolean(accountMenuAnchorEl)}
              onClose={handleAccountMenuClose}
            >
              <MenuItem
                classes={{ root: classes.menuItem }}
                component={Link}
                to="/admin"
              >
                Account
              </MenuItem>

              <MenuItem
                classes={{ root: classes.menuItem }}
                onClick={handleAccountMenuClose}
              >
                <a
                  href="https://www.sofarocean.com/posts/terms-of-use"
                  style={{ color: "#FFF", textDecoration: "none" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of Use
                </a>
              </MenuItem>
              <MenuItem
                component={Link}
                to="/logout"
                classes={{ root: classes.menuItem }}
              >
                Logout
              </MenuItem>
            </Menu>
          </span>
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
};

export default PrivateNavbar;
